/* eslint-disable max-lines */
// TODO replace "svg icons as code" with a "spritesheet and <svg><use /></svg>"
// TODO replace with older 76 76 viewBox 64 64 version of icons (newer style) May need Electron help to resize

export const LoginIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        d="M50.577,46.875c-.045-.012-.091-.042-.147-.058-5.348-1.969-9.485-3.769-10.035-5.929-.536-2.13,.943-3.356,2.947-6.408,.008-.006,.008-.016,.012-.024,3.004-4.65,4.599-10.069,4.595-15.605-.003-11.514-7.14-18.851-15.949-18.851s-15.947,7.336-15.947,18.851c-.005,5.536,1.591,10.955,4.595,15.605,.004,.008,.004,.018,.012,.024,2.003,3.053,3.481,4.279,2.947,6.408-.549,2.16-4.686,3.958-10.035,5.929-.056,.016-.098,.046-.147,.058C4.575,49.452,0,53.172,0,60.644v3.356H64v-3.356c0-7.472-4.573-11.192-13.423-13.769"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

export const PasswordIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        d="M20.516,17.163c0-2.508,.836-10.68,11.484-10.68s11.484,8.187,11.484,10.68v11.689H20.516v-11.689Zm32.416,11.689h-2.966v-11.689C49.966,10.853,46.182,.017,32.014,0,17.817,0,14.064,10.79,14.064,17.163v11.689h-2.997c-1.743,0-3.155,1.413-3.155,3.155v28.838c0,1.742,1.412,3.155,3.155,3.155H52.932c1.745,0,3.155-1.413,3.155-3.155v-28.759c.046-1.742-1.333-3.188-3.075-3.232-.027-.002-.052-.002-.08-.002h0Z"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

export const Individual = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      width={16}
      aria-hidden="true"
      focusable="false"
      height={16}
      {...props}
    >
      <path
        fill="currentColor"
        d="M59.8008235,54.5154706 C59.7471765,54.5020588 59.6935294,54.4685294 59.6287059,54.4506471 C53.352,52.2645294 48.4969412,50.2661765 47.8531765,47.8677059 C47.2228235,45.5027647 48.9596471,44.1414706 51.3089412,40.7527647 C51.3178824,40.7460588 51.3178824,40.7348824 51.3223529,40.7259412 C54.6574118,36.0027647 56.7138824,29.7260588 56.7138824,23.4001765 C56.7138824,10.6165294 48.3382353,2.47111765 38,2.47111765 C27.6617647,2.47111765 19.2861176,10.6165294 19.2861176,23.4001765 C19.2861176,29.7260588 21.3425882,36.0027647 24.6776471,40.7259412 C24.6821176,40.7348824 24.6821176,40.7460588 24.6910588,40.7527647 C27.0425882,44.1414706 28.7771765,45.5027647 28.1468235,47.8677059 C27.5030588,50.2661765 22.648,52.2645294 16.3712941,54.4506471 C16.3064706,54.4685294 16.2572941,54.5020588 16.1991765,54.5154706 C5.81623529,57.3766471 0.447058824,61.5074706 0.447058824,69.8026471 L0.447058824,73.5288824 L75.5529412,73.5288824 L75.5529412,69.8026471 C75.5529412,61.5074706 70.186,57.3766471 59.8008235,54.5154706"
      />
    </svg>
  );
};

export const Electric = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      width={16}
      height={16}
      {...props}
    >
      <path
        d="M50.941,26.249c-.352-.68-1.075-1.067-1.819-1.086l-16.65,.006L40.87,2.712c.352-.938-.043-1.992-.927-2.47-.882-.477-1.981-.231-2.574,.578L13.225,33.735c-.448,.611-.514,1.42-.174,2.094,.342,.676,1.036,1.101,1.793,1.101h15.919l-9.034,24.363c-.349,.94,.048,1.991,.93,2.466,.3,.162,.628,.241,.951,.241,.622,0,1.231-.291,1.621-.821L50.775,28.357c.452-.614,.516-1.432,.166-2.108"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Mail = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      width={16}
      height={16}
      {...props}
    >
      <path
        d="M61.669,15.463s2.315-2.53,2.331,.997V50.192c0,3.005-2.436,5.443-5.443,5.443H5.535c-3.007,0-5.443-2.438-5.443-5.443L0,16.215c-.015-2.975,1.963-1.533,1.963-1.533l24.533,20.546c3.428,2.758,8.315,2.758,11.745,0L61.669,15.463ZM29.056,31.272L3.925,10.342s-1.947-1.978,1.533-1.978H59.032c4.109,.015,.767,2.622,.767,2.622l-24.149,20.286c-1.943,1.498-4.65,1.498-6.593,0Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Gas = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      width={16}
      height={16}
      fill="currentColor"
      {...props}
    >
      <path
        d="M44.275,24.685c-3.563-3.824-6.648-7.126-6.373-12.355,.406-7.416,4.505-10.472,4.664-10.603,.426-.312,.518-.911,.205-1.336-.233-.317-.636-.46-1.017-.358-2.4,.75-4.664,1.879-6.706,3.346-4.208,2.76-6.762,7.439-6.808,12.471v.652c-2.195-2.371-4.964-4.136-8.039-5.128-.51-.136-1.034,.168-1.17,.678-.101,.38,.041,.784,.358,1.017,0,0,3.346,2.448,3.665,8.358,.217,4.114-2.231,6.735-5.055,9.777-3.216,3.476-6.822,7.402-6.822,14.325-.245,5.984,2.792,11.626,7.923,14.716,.135,.068,.284,.102,.435,.101h0c.52,.016,.954-.392,.97-.912,0-.015,0-.029,0-.044-.001-.157-.041-.311-.116-.449-3.143-10.371,.536-14.919,4.432-19.714,2.709-3.346,5.49-6.793,6.214-12.182,1.491,2.598,3.228,5.047,5.185,7.315,4.925,6.069,9.589,11.805,5.504,25.015-.153,.505,.133,1.039,.638,1.192,.236,.071,.49,.049,.709-.062,.391-.203,9.734-5.171,9.763-18.135-.014-8.531-4.548-13.398-8.56-17.686Zm-13.442,16.918c-.303,.168-.452,.52-.362,.855,.681,2.578-1.173,5.794-2.897,8.068-2.81,3.809-2.448,6.677-2.433,6.692-.162,3.58,2.609,6.614,6.189,6.776,.172,.008,.345,.009,.517,.003h.159c3.892-.293,6.851-3.618,6.692-7.518,0-.275,.811-6.706-6.953-14.76-.243-.241-.617-.289-.913-.116Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Calendar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76 76"
      aria-hidden="true"
      focusable="false"
      width={16}
      height={16}
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.676 14.77a2.844 2.844 0 0 1-2.844-2.845V3.25A2.846 2.846 0 0 1 20.676.404 2.847 2.847 0 0 1 23.52 3.25v8.674a2.846 2.846 0 0 1-2.845 2.845Zm34.743 0a2.844 2.844 0 0 1-2.843-2.845V3.25a2.846 2.846 0 1 1 5.69 0v8.674a2.847 2.847 0 0 1-2.847 2.845Zm2.84 55.376v-12.07h11.739v12.07H58.26Zm-17.849 0v-12.07h14.066v12.07H40.41Zm-17.847-32v-11.88h14.066v11.88H22.563Zm0 16.147V41.93h14.066v12.364H22.563Zm0 15.853v-12.07h14.066v12.07H22.563ZM40.41 54.293V41.93h14.066v12.364H40.41Zm0-16.147v-11.88h14.066v11.88H40.41Zm17.85 0v-11.88h11.738v11.88H58.26Zm0 16.147V41.93h11.738v12.364H58.26ZM5.993 38.146v-11.88H18.78v11.88H5.993Zm0 16.147V41.93H18.78v12.364H5.993Zm0 15.853v-12.07H18.78v12.07H5.993Zm70.002.816V10.114a4.635 4.635 0 0 0-4.632-4.635H61.358v5.814a5.99 5.99 0 1 1-11.979 0V5.479H26.616v5.814a5.99 5.99 0 0 1-11.981 0V5.479H4.634A4.635 4.635 0 0 0 0 10.114v60.848a4.633 4.633 0 0 0 4.634 4.634h66.729c4.978-.072 4.632-4.634 4.632-4.634Z"
      />
    </svg>
  );
};

export const OutdoorLight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76 76"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M42.3563887,58.0525764 L42.3416657,58.0525764 L42.3416657,74.7058421 C42.3416657,75.1048373 42.2459657,75.4994156 42.0619273,75.8542416 C40.9135278,76 39.8534667,76 38.5578364,76 C37.2622061,76 35.9665759,76 34.7740071,75.8233231 C34.595858,75.477331 34.4986857,75.0945311 34.4942688,74.7058421 L34.4942688,58.0098795 L27.69221,52.8258862 C27.6141777,52.7993846 27.5464516,52.7478539 27.4978654,52.6816001 C27.3638855,52.4975617 27.4051101,52.2399079 27.5891485,52.1044557 C27.6642361,52.0396742 27.7496299,51.9851988 27.8394407,51.9439742 C28.1589313,51.8026327 28.5063958,51.731962 28.8553326,51.7363789 L47.9953249,51.7363789 C48.4517401,51.7113497 48.9022661,51.8409127 49.2762321,52.1044557 C49.3424859,52.1500972 49.3940167,52.2134064 49.4249351,52.2870218 C49.5118013,52.499034 49.4131567,52.7390201 49.2026168,52.8258862 L42.3563887,58.0525764 Z M56.4021985,14.6050882 C56.9027829,14.8553804 56.9469521,15.1498418 56.5347061,15.4148571 C55.8618618,15.7225693 55.1242359,15.8639108 54.3851378,15.8271031 L22.3919044,15.8271031 C21.8191769,15.8329923 21.2479218,15.7534877 20.6987512,15.591534 C20.5485759,15.5444201 20.4057621,15.4811109 20.2717822,15.400134 C19.8595362,15.1498418 19.9184285,14.8406573 20.4337359,14.6050882 L36.187422,6.49267606 C35.9386021,6.30127614 35.7162837,6.07895776 35.5248838,5.83161017 C34.3058135,4.24446311 34.6017472,1.97122094 36.187422,0.75215066 C37.7730967,-0.468391929 40.0478112,-0.172458201 41.2668815,1.41468886 C42.4859518,2.9988913 42.190018,5.27360578 40.6043433,6.49267606 L56.4021985,14.6050882 Z M52.6179276,18.4778448 C53.9017793,18.6088801 54.8484728,19.7381397 54.7527729,21.0249361 L49.7322056,46.7461412 C49.8264333,48.0476607 48.8547106,49.1828095 47.5546634,49.2932325 L29.2524138,49.2932325 C27.9523666,49.1828095 26.9806439,48.0476607 27.0733993,46.7461412 L22.0086629,21.0249361 C21.9159075,19.7219443 22.8876302,18.5867955 24.1876774,18.4778448 L52.6179276,18.4778448 Z"
      />
    </svg>
  );
};

export const PencilSolid = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        d="M11.936,46.196L38.81,8.688l11.521,8.253L23.459,54.45l-15.561,9.55,4.039-17.804ZM54.419,4.308c1.811,1.298,2.226,3.819,.928,5.63l-.002,.002-3.697,5.161-11.521-8.253,3.701-5.165c1.3-1.812,3.822-2.226,5.634-.926,0,0,0,0,0,0l4.957,3.55Z"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

export const PaperDollar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        d="M45.418,48.453l5.423-.061c1.023,0,2.034-.237,2.95-.691-.856,1.538-1.887,2.97-3.072,4.271l-7.697,8.096c-.899,.851-1.893,1.595-2.963,2.212,.495-.948,.753-2.003,.751-3.072v-6.145c.041-2.529,2.08-4.569,4.609-4.609ZM49.875,0c2.982,.025,5.389,2.441,5.406,5.423V41.095c-.015,2.559-2.049,4.649-4.609,4.732h-6.145c-3.665,.009-6.629,2.986-6.62,6.652v6.913c0,2.498-1.989,4.543-4.486,4.609H14.171c-3.011,0-5.452-2.443-5.452-5.454V5.438c.008-3.006,2.447-5.438,5.452-5.438H49.875Zm-10.079,38.268v.015c1.287-1.873,1.376-4.321,.23-6.283-.553-1.006-1.378-1.836-2.38-2.397-1.292-.661-2.667-1.146-4.088-1.444v-5.377c.158,.068,.313,.144,.461,.23,.613,.353,1.163,.805,1.63,1.337,.25,.359,.725,.484,1.12,.292l2.688-.983s.8-.184,.094-.983c-.306-.375-.633-.728-.985-1.06-.851-.708-1.816-1.264-2.856-1.644-.722-.255-1.469-.426-2.228-.507v-2.519c0-.296-.241-.538-.538-.538h-1.92c-.298,0-.539,.241-.539,.538v2.489c-1.67,.089-3.275,.677-4.609,1.69-1.37,1.08-2.155,2.741-2.118,4.486-.005,1.681,.802,3.258,2.165,4.24,1.398,.945,2.962,1.616,4.609,1.982v6.053c-.306-.084-.605-.197-.889-.338-.782-.475-1.464-1.097-2.012-1.828-.186-.303-.568-.422-.893-.277l-3.072,1.06c-.118,.018-.226,.078-.306,.169-.19,.217-.171,.545,.046,.736,1.02,1.63,2.547,2.877,4.348,3.55,.886,.343,1.817,.558,2.764,.645v2.473c0,.298,.241,.538,.539,.538h1.92c.296,0,.538-.24,.538-.538v-2.473c1.105-.1,2.188-.369,3.209-.799,1.261-.508,2.335-1.393,3.072-2.535Zm-11.613-13.135c-.003-.751,.343-1.461,.937-1.92,.401-.316,.868-.538,1.367-.645v4.824c-.538-.157-1.046-.401-1.506-.722-.493-.358-.79-.926-.799-1.536Zm5.377,7.528c.734,.209,1.421,.553,2.028,1.014,.525,.43,.836,1.071,.845,1.751-.014,.793-.409,1.53-1.06,1.98-.533,.395-1.155,.648-1.813,.739v-5.484Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Power = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76 76"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M60.0853948,17.2891332 C67.8588354,24.2555258 71.9127566,34.2165893 71.2121942,44.6185401 C70.0165677,62.3605168 55.1964033,76 37.6673975,76 C36.9107901,76 36.1485782,75.9757138 35.38263,75.9234052 C26.4172992,75.3181192 18.2235212,71.2585936 12.3107744,64.4920947 C6.39802758,57.7255958 3.4743471,49.0610399 4.07776486,40.093841 C4.68305079,31.1285102 8.74257647,22.9347322 15.5090753,17.0219854 C17.3529556,15.4116259 20.1514689,15.6021789 21.7599603,17.4423228 C23.3703197,19.2843349 23.1816349,22.0847164 21.3396228,23.6932077 C16.3534866,28.0497719 13.3625521,34.0858177 12.9179285,40.689786 C12.4733049,47.2956226 14.6273008,53.6772792 18.9819968,58.6615472 C23.3385609,63.6476835 29.3746067,66.638618 35.9785751,67.0832416 C49.6068493,68.0117203 61.4528927,57.6564737 62.3720306,44.022595 C62.8895127,36.3593762 59.8985782,29.0212184 54.1707799,23.8856289 C52.3493176,22.2528514 52.196128,19.4524699 53.8307736,17.6310076 C55.4635511,15.8076772 58.2639326,15.6544875 60.0853948,17.2891332 Z M36.9814068,36.5637536 C34.6574077,36.5637536 32.7724278,34.6787737 32.7724278,32.3547746 L32.7724278,4.21084716 C32.7724278,1.88497994 34.6574077,6.03961325e-14 36.9814068,6.03961325e-14 C39.307274,6.03961325e-14 41.192254,1.88497994 41.1903872,4.21084716 L41.1903872,32.3547746 C41.1903872,34.6769055 39.3054059,36.5637536 36.9814068,36.5637536 Z"
      />
    </svg>
  );
};

export const Location = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76 76"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        d="M51.406,4.393A21.413,21.413,0,0,0,21.393,34.408S35.114,55.371,36.628,73.324c0,0,.081,2.676,1.784,2.676S40.2,73.324,40.2,73.324c1.515-17.953,15.238-38.916,15.238-38.916A21.413,21.413,0,0,0,51.406,4.393Zm-2.18,16.561A10.814,10.814,0,1,1,38.411,10.138,10.813,10.813,0,0,1,49.226,20.954Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Hash = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={16}
      height={16}
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path
        d="M25.191,36.814l2.062-9.624h11.615l-2.009,9.624h-11.668Zm31.213-9.624c1.529,0,2.768-1.239,2.768-2.77v-5.011c0-1.529-1.239-2.77-2.768-2.77h-4.649l2.757-13.308c.169-.814-.037-1.664-.564-2.311-.526-.645-1.312-1.02-2.145-1.02h-5.013c-1.309,0-2.439,.919-2.708,2.204l-3.015,14.435h-11.604l2.776-13.304c.171-.816-.035-1.665-.561-2.311-.526-.647-1.314-1.024-2.147-1.024h-5.011c-1.311,0-2.439,.917-2.709,2.2l-3.033,14.439H7.594c-1.527,0-2.766,1.241-2.766,2.77v5.011c0,1.531,1.239,2.77,2.766,2.77h8.968l-2.038,9.707H7.594c-1.527,0-2.766,1.237-2.766,2.766v5.055c0,1.527,1.239,2.766,2.766,2.766h4.704l-2.77,13.181c-.171,.814,.035,1.664,.561,2.312,.526,.645,1.314,1.022,2.149,1.022h5.093c1.311,0,2.443-.919,2.711-2.202l2.985-14.314h11.602l-2.752,13.183c-.169,.816,.035,1.664,.561,2.311,.526,.645,1.316,1.022,2.149,1.022h5.095c1.312,0,2.443-.921,2.709-2.204l2.967-14.312h11.045c1.529,0,2.768-1.239,2.768-2.766v-5.055c0-1.529-1.239-2.766-2.768-2.766h-8.849l2.011-9.707h6.838Z"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

export const Phone = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={14}
      fill="currentColor"
      height={18}
      viewBox="0 0 14 18"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.17582401,0.000789604343 L4.24963475,5.41459023 C4.24963475,5.41459023 2.17425044,5.84008744 4.24963475,10.0776922 C5.84394672,14.0091561 7.42067436,13.4914346 7.72007677,13.3485756 L7.75231716,13.3321727 C7.76454209,13.3255054 7.77084119,13.3214571 7.77084119,13.3214571 L11.7566211,16.9898509 C11.5444306,17.1782373 6.76528785,21.26337 1.54903006,11.5278562 C-2.76083483,0.533467443 3.19827476,0.0180748744 4.07156523,0.000541184559 L4.17582401,0.000789604343 Z M8.46431479,12.4711574 C8.89328544,12.0122283 9.61315724,11.9887825 10.0720864,12.4181873 L12.3906119,14.5669482 C12.8521461,14.9993923 12.8764603,15.7196983 12.4470554,16.1781932 L12.2429905,16.4039673 L8.25721054,12.6999707 L8.46127553,12.4746309 Z M5.24403908,0.0308783351 L5.3685431,0.0352342944 C5.93960447,0.0863029639 6.39195527,0.560347371 6.40330187,1.14672304 L6.46408718,4.29019217 L6.45973122,4.41470159 C6.40866255,4.98581159 5.93461814,5.4385136 5.34824248,5.44945495 L5.0443159,5.44945495 L4.9357707,0.0308783351 L5.24403908,0.0308783351 Z"
        id="path-1"
      ></path>
    </svg>
  );
};

export const Identification = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 14"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.7830223,10.230843 C16.0286157,10.230843 16.2277454,10.4299727 16.2277454,10.675566 C16.2277454,10.9211594 16.0286157,11.1202891 15.7830223,11.1202891 L2.43469282,11.1202891 C2.18909949,11.1202891 1.99041227,10.9211594 1.99041227,10.675566 C1.99041227,10.4299727 2.18909949,10.230843 2.43469282,10.230843 L15.7830223,10.230843 Z M5.21587138,0.948300022 C6.21948521,1.00007375 6.53986282,1.58994026 6.58145881,2.58249133 C6.62261229,3.57548492 5.91902058,4.38262409 5.91902058,4.38262409 C5.96061656,4.67202596 7.26425253,5.16896526 7.88465226,5.39641566 C8.50549451,5.62386607 8.56744598,7.48329523 8.56744598,7.48329523 L8.56744598,7.8147356 C8.56744598,7.98598717 8.42849768,8.12493547 8.25724611,8.12493547 L2.13776827,8.12493547 C1.96607419,8.12493547 1.82712589,7.98598717 1.82712589,7.8147356 L1.82845343,7.48329523 C1.82845343,7.48329523 1.8904049,5.62386607 2.51080463,5.39641566 C3.13164688,5.16896526 4.43484033,4.67202596 4.47643632,4.38262409 C4.47643632,4.38262409 3.77284461,3.57548492 3.81444059,2.58249133 C3.85559407,1.58994026 4.17641419,1.00007375 5.18002803,0.948300022 L5.21587138,0.948300022 Z M15.7830223,4.87425326 C16.0286157,4.87425326 16.2277454,5.07338299 16.2277454,5.31897633 C16.2277454,5.56501217 16.0286157,5.76369939 15.7830223,5.76369939 L10.8423925,5.76369939 C10.5967992,5.76369939 10.398112,5.56501217 10.398112,5.31897633 C10.398112,5.07338299 10.5967992,4.87425326 10.8423925,4.87425326 L15.7830223,4.87425326 Z M15.7830223,2.19617966 C16.0286157,2.19617966 16.2277454,2.39530939 16.2277454,2.64090272 C16.2277454,2.88649605 16.0286157,3.08562578 15.7830223,3.08562578 L10.8423925,3.08562578 C10.5967992,3.08562578 10.398112,2.88649605 10.398112,2.64090272 C10.398112,2.39530939 10.5967992,2.19617966 10.8423925,2.19617966 L15.7830223,2.19617966 Z M16.9171768,0 L1.08238071,0 C0.484549008,0 0,0.484549008 0,1.08238071 L0,11.7163508 C0,12.3141825 0.484549008,12.7987315 1.08238071,12.7987315 L16.9171768,12.7987315 C17.515451,12.7987315 18,12.3141825 18,11.7163508 L18,1.08238071 C18,0.484549008 17.515451,0 16.9171768,0"></path>
    </svg>
  );
};

export const GovBuilding = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 76 76"
      width={18}
      height={18}
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path d="M5.351 16.863c-1.332-.219-1.803-.925-1.066-1.568L30.041.482a4.42 4.42 0 0 1 4.013 0l25.74 14.814c.737.674.266 1.395-1.066 1.568H5.351Zm53.878 43.814a1.3 1.3 0 0 1 1.097 1.442v.439A1.3 1.3 0 0 1 59.229 64H4.771a1.3 1.3 0 0 1-1.097-1.442v-.439a1.3 1.3 0 0 1 1.097-1.442zm-1.536-5.33a1.3 1.3 0 0 1 1.097 1.442v.439a1.3 1.3 0 0 1-1.097 1.442H6.746a1.3 1.3 0 0 1-1.097-1.442v-.439a1.3 1.3 0 0 1 1.097-1.442zm-2.179-36.462a1.16 1.16 0 0 1 1.097 1.219v.379a1.16 1.16 0 0 1-1.094 1.223H9.395a1.16 1.16 0 0 1-1.097-1.219v-.379a1.16 1.16 0 0 1 1.094-1.223h46.121ZM14.851 23.87a1.13 1.13 0 0 1 1.207 1.003l.455 27.48a.94.94 0 0 1-.345.737 1.33 1.33 0 0 1-.862.298h-4.515c-.313.005-.619-.1-.862-.298a.94.94 0 0 1-.345-.737l.47-27.464c.066-.605.6-1.049 1.207-1.003zm37.935 0a1.13 1.13 0 0 1 1.207 1.003l.455 27.48a.94.94 0 0 1-.345.737 1.33 1.33 0 0 1-.862.298h-4.515c-.313.005-.619-.1-.862-.298a.94.94 0 0 1-.345-.737l.455-27.401c.066-.605.6-1.049 1.207-1.003zm-12.65 0a1.13 1.13 0 0 1 1.207 1.003l.455 27.48a.94.94 0 0 1-.345.737 1.33 1.33 0 0 1-.862.298h-4.515c-.313.005-.619-.1-.862-.298a.94.94 0 0 1-.345-.737l.455-27.401c.066-.605.6-1.049 1.207-1.003zm-12.65 0a1.13 1.13 0 0 1 1.207 1.003l.47 27.48a.94.94 0 0 1-.345.737 1.33 1.33 0 0 1-.862.298h-4.53c-.313.005-.619-.1-.862-.298a.94.94 0 0 1-.345-.737l.455-27.401c.066-.605.6-1.049 1.207-1.003z"></path>
    </svg>
  );
};

export const Person = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 76 76"
      width={18}
      height={18}
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      {...props}
    >
      <path d="M59.8 54.515c-.053-.013-.106-.046-.171-.064-6.277-2.186-11.132-4.185-11.776-6.583-.63-2.365 1.107-3.727 3.456-7.115.009-.007.009-.018.013-.027 3.335-4.723 5.392-11 5.392-17.326 0-12.783-8.376-20.929-18.714-20.929s-18.714 8.146-18.714 20.93c0 6.325 2.057 12.602 5.392 17.325.004.009.004.02.013.027 2.352 3.388 4.086 4.75 3.456 7.115-.644 2.398-5.499 4.397-11.776 6.583-.065.018-.114.051-.172.064C5.816 57.377.447 61.507.447 69.803v3.726h75.106v-3.726c0-8.296-5.367-12.426-15.752-15.288" />
    </svg>
  );
};

export const Check = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="13 13 46 46"
      width={16}
      height={16}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M70,35A35,35,0,1,1,35,0,35,35,0,0,1,70,35" fill="currentColor" />
      <path
        d="M56.37,15.09A2.46,2.46,0,0,0,53,14.71c-.5.37-12,9.07-26.54,28.86L17,36.38a2.46,2.46,0,0,0-3.37,3.55l12.64,15a2.46,2.46,0,0,0,4.18-.72c.07-.18,6.87-17.84,25.73-35.72A2.46,2.46,0,0,0,56.37,15.09Z"
        fill="#fff"
      />
    </svg>
  );
};

export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      width={16}
      height={16}
      aria-hidden="true"
      focusable="false"
      data-testid="error-icon"
      {...props}
    >
      <path
        d="M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32,32-14.327,32-32S49.673,0,32,0Zm4.312,45.291h0c0,2.38-1.929,4.308-4.308,4.308-2.379,0-4.307-1.929-4.307-4.308v-.301c.08-2.296,2.005-4.092,4.301-4.013,.068-.003,.136-.003,.208,.003,2.296,.03,4.134,1.914,4.106,4.211v.101Zm.099-28.365l-2.13,18.602c-.07,1.151-.988,2.069-2.139,2.139-1.258,.077-2.34-.881-2.416-2.139l-2.131-18.602c-.152-1.432,.64-2.526,1.979-2.526h4.842c1.347,0,2.131,1.095,1.996,2.526Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const SuccessIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      width={16}
      height={16}
      aria-hidden="true"
      focusable="false"
      data-testid="success-icon"
      {...props}
    >
      <path
        d="M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32,32-14.327,32-32S49.673,0,32,0Zm20.33,16.868c-17.725,16.803-24.12,33.405-24.184,33.574-.289,.768-.964,1.325-1.773,1.464-.129,.022-.26,.033-.392,.034-.682,0-1.329-.301-1.768-.822l-11.877-14.074c-.824-.977-.7-2.437,.276-3.261,.827-.698,2.027-.729,2.889-.076l8.915,6.749c13.66-18.598,24.471-26.771,24.938-27.121,1.018-.772,2.47-.573,3.242,.445,.718,.946,.603,2.282-.266,3.092v-.003Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      width={16}
      height={16}
      aria-hidden="true"
      focusable="false"
      data-testid="warning-icon"
      {...props}
    >
      <path
        d="M63.259,52.175h0S36.796,6.294,36.796,6.294c-1.528-2.648-4.912-3.558-7.561-2.03-.842,.487-1.542,1.187-2.03,2.03L.742,52.174c-1.528,2.646-.622,6.033,2.026,7.561,.842,.485,1.797,.742,2.769,.742H58.463c3.056,.002,5.535-2.476,5.537-5.534,0-.973-.256-1.927-.741-2.769Zm-26.034,0c-.156,2.882-2.616,5.093-5.496,4.939-2.667-.142-4.797-2.272-4.939-4.939v-.119c.152-2.882,2.614-5.093,5.496-4.941,2.665,.143,4.795,2.274,4.939,4.941v.119Zm.119-34.351h0s0-.005,0-.007v-.008l-2.59,22.556c-.113,1.524-1.438,2.669-2.963,2.557-1.369-.101-2.458-1.188-2.557-2.557l-2.575-22.541c-.32-1.336,.504-2.677,1.84-2.997,.179-.041,.36-.065,.543-.067h5.92c1.372,.019,2.47,1.149,2.451,2.522-.002,.18-.027,.359-.067,.535v.007Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const LoadingIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 128 128"
      fill="currentColor"
      data-testid="loading-icon"
      {...props}
    >
      <g>
        <circle cx={14} cy={64} r={14} />
        <circle cx={13} cy={64} r={13} fillOpacity={0.8} transform="rotate(315 64 64)" />
        <circle cx={12} cy={64} r={12} fillOpacity={0.6} transform="rotate(270 64 64)" />
        <circle cx={11} cy={64} r={11} fillOpacity={0.5} transform="rotate(225 64 64)" />
        <circle cx={10} cy={64} r={10} fillOpacity={0.4} transform="rotate(180 64 64)" />
        <circle cx={9} cy={64} r={9} fillOpacity={0.3} transform="rotate(135 64 64)" />
        <circle cx={8} cy={64} r={8} fillOpacity={0.2} transform="rotate(90 64 64)" />
        <circle cx={7} cy={64} r={7} fillOpacity={0.1} transform="rotate(45 64 64)" />
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="45 64 64;90 64 64;135 64 64;180 64 64;225 64 64;270 64 64;315 64 64;0 64 64"
          calcMode="discrete"
          dur="960ms"
          repeatCount="indefinite"
        />
      </g>
    </svg>
  );
};

export const ChevronDown = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 64 64"
      width={16}
      height={16}
      {...props}
    >
      <path
        d="M57.404,16.997c1.634-1.441,4.123-1.304,5.588,.308,1.442,1.59,1.323,4.048-.268,5.491-.015,.013-.029,.026-.044,.039l-27.307,24.169c-1.479,1.304-3.688,1.332-5.199,.067L1.397,22.905c-1.649-1.376-1.869-3.828-.493-5.476,.012-.015,.025-.029,.037-.044,1.424-1.65,3.908-1.851,5.578-.451l26.148,21.956,24.737-21.893Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
